/**
 * @file
 * @author (zhangwenting)
 */

/* global document */

import React from 'react';
import ReactDOM from 'react-dom';

import Notification from './Notification';
import { classPrefix } from '../../common/util';

function display(config) {
    var body = document.body;
    var notice = document.getElementById('notice');
    var level = config && config.level || 999;
    var container = document.createElement('div');
    if (!notice) {
        var div = document.createElement('div');
        div.innerHTML = '<div class="' + classPrefix + '-notification-block"\n                              style="position:fixed;\n                              top:10px;\n                              width:auto;\n                              right:10px;\n                              z-index:' + level + '">\n                              <span id="notice"></span>\n                           </div>';
        body.appendChild(div);
        notice = document.getElementById('notice');
    }

    var close = function close(callBack) {
        if (container) {
            ReactDOM.unmountComponentAtNode(container);
            notice.removeChild(container);
        }
        if (callBack) {
            callBack();
        }
    };
    if ('onCancel' in config) {
        config.onCancel = close.bind(this, config.onCancel);
    } else {
        config.onCancel = close;
    }

    notice.insertBefore(container, notice.childNodes[0]);
    ReactDOM.render(React.createElement(Notification, config), container);
}

var m = Notification;
m.display = display;
export default m;